import { getApiClient } from './api';

// PATCH /facilities - update the logged-in user's facility (admin only).
const updateFacility = async (payload) => {
  try {
    const api = getApiClient();
    const res = await api({
      method: 'PATCH',
      url: '/facilities',
      data: payload,
    });

    return res;
  } catch (error) {
    return error.response?.data;
  }
};

export { updateFacility };
